import React, { useState, useRef } from "react";
import { Button } from "@/modern/components/ui/button";
import { FlaskConical } from "lucide-react";
import TestPromptModal from "@/react/components/entityViews/settings/components/TestPromptModal";
// @ts-expect-error - userPreferences is dynamically set in bryntumContext
import { userPreferences } from "@/react/context/bryntumContext.jsx";
import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";
import { InspectionType, AdvisorType, PromoteType } from "../constants/settingsStructure";
import { useBoardPermissions } from "../hooks/useBoardPermissions";

interface TestPromptButtonProps {
  inspectionType?: InspectionType;
  advisorType?: AdvisorType;
  promoteType?: PromoteType;
}

const TestPromptButton = ({ inspectionType, advisorType, promoteType }: TestPromptButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const editorInstanceRef = useRef({ editorRef: { toFront: () => {} } });

  // @ts-expect-error - userPreferences is dynamically set in bryntumContext
  const hasOpenAIKey = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.hasOpenAiApiKey, "false", true) === "true";

  // Use shared permission hook
  const { canWrite } = useBoardPermissions();

  const isDisabled = !hasOpenAIKey || !canWrite;

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="default"
        size="sm"
        className="shadow-sm !gap-0"
        disabled={isDisabled}
        title={!hasOpenAIKey ? "OpenAI API key required" : !canWrite ? "Board Owner permission required" : "Test the AI prompt with an image"}
      >
        <FlaskConical className="h-4 w-4 mr-2" />
        Test Prompt
      </Button>

      {isModalOpen && (
        <TestPromptModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          editorInstance={editorInstanceRef.current}
          inspectionType={inspectionType}
          advisorType={advisorType}
          promoteType={promoteType}
        />
      )}
    </>
  );
};

export default TestPromptButton;
